module.exports = __webpack_public_path__ + "img/platform-3.7efb05cd.png";